import { render } from "./TerminosYCondicionesStripe.vue?vue&type=template&id=d4c267b2&scoped=true"
const script = {}

import "./TerminosYCondicionesStripe.vue?vue&type=style&index=0&id=d4c267b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c267b2"]])

export default __exports__